/**
 * V2.1-H — small inline SVG icons for sidebar nav items.
 *
 * 16x16 viewBox, stroke-width 1.6, no fill, currentColor stroke.
 * Display sized to ~14px by the consumer. Match the design ref's
 * line-art weight + simplicity.
 */

const SVG_PROPS = {
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function IconWebsites() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2" y="2" width="5" height="5" rx="1" />
      <rect x="9" y="2" width="5" height="5" rx="1" />
      <rect x="2" y="9" width="5" height="5" rx="1" />
      <rect x="9" y="9" width="5" height="5" rx="1" />
    </svg>
  );
}

export function IconVideo() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2" y="4" width="9" height="8" rx="1.5" />
      <path d="m11 7 3-2v6l-3-2z" />
    </svg>
  );
}

export function IconClients() {
  return (
    <svg {...SVG_PROPS}>
      <circle cx="6" cy="6" r="2.5" />
      <path d="M2 13a4 4 0 0 1 8 0" />
      <circle cx="11.5" cy="7" r="1.8" />
      <path d="M14 13a3 3 0 0 0-3-3" />
    </svg>
  );
}

export function IconSupportTasks() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2.5" y="3" width="11" height="11" rx="1.5" />
      <path d="m5 8 2 2 4-4" />
    </svg>
  );
}

export function IconIlyc() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M8 14s-5-3.2-5-7a3 3 0 0 1 5-2 3 3 0 0 1 5 2c0 3.8-5 7-5 7Z" />
    </svg>
  );
}

export function IconSeo() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M3 13V8M7 13V5M11 13V9M15 13V3" />
    </svg>
  );
}

export function IconBilling() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2" y="3" width="12" height="10" rx="1.5" />
      <path d="M2 6h12M5 10h3" />
    </svg>
  );
}

export function IconOrders() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M2 5h10l-2-2M14 11H4l2 2" />
    </svg>
  );
}

export function IconRates() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M3 8h10M3 8l3-3M3 8l3 3M13 14V4" />
    </svg>
  );
}

export function IconCommissions() {
  return (
    <svg {...SVG_PROPS}>
      <circle cx="8" cy="8" r="6" />
      <path d="M10 6.5C9.4 5.6 8.4 5 7.3 5c-1.6 0-2.8 1-2.8 2.4 0 2.5 5 1.8 5 4.4 0 1.4-1.2 2.4-2.8 2.4-1.1 0-2.1-.6-2.7-1.5M8 4v8" />
    </svg>
  );
}

export function IconRevenue() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2" y="3" width="12" height="4" rx="1" />
      <rect x="4" y="9" width="10" height="4" rx="1" />
    </svg>
  );
}

export function IconCheckIn() {
  // Notebook glyph — three horizontal lines + spine.
  return (
    <svg {...SVG_PROPS}>
      <rect x="3" y="2.5" width="10" height="11" rx="1" />
      <path d="M3 5h10M3 8h10M3 11h6M5 2.5v11" />
    </svg>
  );
}

export function IconMyTasks() {
  // Wave 2b — checklist glyph for "Mine opgaver" sidebar item.
  return (
    <svg {...SVG_PROPS}>
      <path d="m3 5 1.5 1.5L7 4" />
      <path d="m3 11 1.5 1.5L7 9" />
      <path d="M9 5h5M9 11h5" />
    </svg>
  );
}

export function IconTrialWorkflow() {
  return (
    <svg {...SVG_PROPS}>
      <circle cx="3.5" cy="8" r="1.5" />
      <circle cx="8" cy="8" r="1.5" />
      <circle cx="12.5" cy="8" r="1.5" />
      <path d="M5 8h1.5M9.5 8h1.5" />
    </svg>
  );
}

export function IconUsers() {
  return (
    <svg {...SVG_PROPS}>
      <circle cx="8" cy="6" r="2.5" />
      <path d="M3 14a5 5 0 0 1 10 0" />
    </svg>
  );
}

/**
 * Wave 7 (PR #20) — checklist-template glyph used by /checklist-templates
 * in the admin sidebar.
 */
export function IconChecklistTemplates() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="3" y="2.5" width="10" height="11" rx="1" />
      <path d="m5 6 1.5 1.5L9 4.5" />
      <path d="m5 11 1.5 1.5L9 9.5" />
      <path d="M11 6h.5M11 11h.5" />
    </svg>
  );
}

/**
 * Wave 7 (PR #20) — subscription glyph used by /subscriptions in the
 * admin sidebar (replaces the IconBilling reuse there).
 */
export function IconSubscriptions() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M3 8a5 5 0 0 1 8.5-3.5L13 3v3.5h-3.5" />
      <path d="M13 8a5 5 0 0 1-8.5 3.5L3 13V9.5h3.5" />
    </svg>
  );
}
